// Maps EditOrderModal's modifyOrder-shaped fieldsToEdit onto the
// api/catering-draft-order/edit contract. The modal speaks modifyOrder's
// vocabulary (user_desired_time, items-with-special_instructions); the catering
// handler accepts a different set (fulfillment_date, items_to_add/remove,
// draft_edit_count, card_id, catering_method) and silently ignores the rest.
// Renaming + stripping here keeps the silent-ignore from looking like success.
// TODO: extend the backend catering-draft edit handler to accept per-item
// special_instructions so terminal staff can update them.
export function buildCateringEditPayload(orderId, fieldsToEdit) {
  const { user_desired_time, items: _itemSpecialInstructions, ...rest } = fieldsToEdit || {};
  return {
    orderId,
    ...rest,
    ...(user_desired_time !== undefined ? { fulfillment_date: user_desired_time } : {}),
  };
}
